import { AlertDialog, AlertDialogContent } from '@/components/ui/alert-dialog';
import { useAtomValue } from 'jotai';
import { currentSelectjobChangeProcessLogStatusAtom } from '../../atoms/jobChangeProcess';
import LogStatusConfirmModalContents from './LogStatusConfirmModalContents';
import LogDeleteConfirmModalContents from './LogDeleteConfirmModalContents';
type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  jobchangeProcessesRefetch: () => Promise<void>;
};

export default function JobChangeProcessLogStatusUpdateModal({
  open,
  onOpenChange,
  jobchangeProcessesRefetch,
}: Props) {
  const currentSelectjobChangeProcessLogStatus = useAtomValue(
    currentSelectjobChangeProcessLogStatusAtom
  );

  const close = () => onOpenChange(false);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-h-[90vh] max-w-max overflow-auto">
        {currentSelectjobChangeProcessLogStatus !== null && (
          <>
            {currentSelectjobChangeProcessLogStatus!.type === 'edit' && (
              <LogStatusConfirmModalContents
                close={close}
                jobchangeProcessesRefetch={jobchangeProcessesRefetch}
              />
            )}
            {currentSelectjobChangeProcessLogStatus!.type === 'delete' && (
              <LogDeleteConfirmModalContents
                close={close}
                jobchangeProcessesRefetch={jobchangeProcessesRefetch}
              />
            )}
          </>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}
